var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("g-breadcrumb", {
        attrs: { paginas: _vm.paginaStatus.caminhoMigalha }
      }),
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.salvar($event)
            }
          }
        },
        [
          _c(
            "g-gridview",
            {
              ref: "refDocumentos",
              attrs: {
                id: "refDocumentos",
                name: "refDocumentos",
                exibirEtiqueta: false,
                colunas: _vm.colunasGridDocumentos,
                inserirElemento: _vm.getElemento,
                getElemento: _vm.getElemento,
                editarElemento: _vm.editarElemento,
                executarValidacao: _vm.validarDocumento,
                limparCampos: _vm.limparDocumento,
                exibirBotaoVisualizacao: _vm.visualizacao,
                exibirBotaoEdicao: _vm.edicao,
                exibirBotaoExclusao: _vm.exclusao,
                confExcluir: _vm.confExcluirDocumento,
                inicializarVazio: true
              }
            },
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-sm-6 col-xs-6" },
                  [
                    _c("g-input", {
                      ref: "refCodigo",
                      attrs: {
                        id: "refCodigo",
                        name: "refCodigo",
                        tipo: "text",
                        etiqueta: "Código",
                        validacao: "numeric",
                        desabilitar: true,
                        foco: false
                      },
                      model: {
                        value:
                          _vm.documentoNecessarioSelecionado
                            .codDocumentacaoNecessaria,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.documentoNecessarioSelecionado,
                            "codDocumentacaoNecessaria",
                            $$v
                          )
                        },
                        expression:
                          "documentoNecessarioSelecionado.codDocumentacaoNecessaria"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-sm-12 col-xs-12" },
                  [
                    _c("g-autocomplete", {
                      ref: "refTipoProcesso",
                      attrs: {
                        id: "refTipoProcesso",
                        name: "refTipoProcesso",
                        etiqueta: "Tipo de Processo",
                        descricaoPrimaria: "desTipoProcesso",
                        valor: "codTipoProcesso",
                        foco: false,
                        api: _vm.apiTipoProcesso,
                        desabilitar: _vm.desabilitarcampos
                      },
                      model: {
                        value: _vm.codTipoProcesso,
                        callback: function($$v) {
                          _vm.codTipoProcesso = $$v
                        },
                        expression: "codTipoProcesso"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-sm-12 col-xs-12" },
                  [
                    _c("g-autocomplete", {
                      ref: "refAssunto",
                      attrs: {
                        id: "refAssunto",
                        name: "refAssunto",
                        etiqueta: "Assunto",
                        valor: "codAssunto",
                        descricaoPrimaria: "desAssunto",
                        foco: false,
                        api: _vm.apiAssunto,
                        desabilitar: _vm.desabilitarAssunto
                      },
                      model: {
                        value: _vm.codAssunto,
                        callback: function($$v) {
                          _vm.codAssunto = $$v
                        },
                        expression: "codAssunto"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-sm-12 col-xs-12" },
                  [
                    _c("g-autocomplete", {
                      ref: "refSubAssunto",
                      attrs: {
                        id: "refSubAssunto",
                        name: "refSubAssunto",
                        etiqueta: "Subassunto",
                        valor: "codSubassunto",
                        descricaoPrimaria: "desSubassunto",
                        api: _vm.apiSubAssunto,
                        foco: false,
                        desabilitar: _vm.desabilitarSubAssunto,
                        filtroAdicional: _vm.filtroPesquisaSubAssunto
                      },
                      model: {
                        value: _vm.codSubassunto,
                        callback: function($$v) {
                          _vm.codSubassunto = $$v
                        },
                        expression: "codSubassunto"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-sm-12 col-xs-12" },
                  [
                    _c("g-autocomplete", {
                      ref: "refDocumento",
                      attrs: {
                        id: "refDocumento",
                        name: "refDocumento",
                        etiqueta: "Documento",
                        valor: "codDocumento",
                        descricaoPrimaria: "nomDocumento",
                        api: _vm.apiDocumento,
                        foco: false,
                        desabilitar: _vm.desabilitarDocumento
                      },
                      model: {
                        value: _vm.codDocumento,
                        callback: function($$v) {
                          _vm.codDocumento = $$v
                        },
                        expression: "codDocumento"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v("\n       \n      "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-5 col-md-5" },
                  [
                    _c("g-option", {
                      ref: "refAtivo",
                      attrs: {
                        id: "ativo",
                        name: "ativo",
                        tipo: "radio",
                        option: _vm.arrayAtivoEnum,
                        desabilitar: _vm.paginaStatus.desabilitarEdicao,
                        etiqueta: "Ativo",
                        validacao: "required"
                      },
                      model: {
                        value: _vm.indAtivo,
                        callback: function($$v) {
                          _vm.indAtivo = $$v
                        },
                        expression: "indAtivo"
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-12 text-right pad-20t-h10-80b" },
        [
          _c(
            "q-btn",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.paginaStatus.desabilitarEdicao,
                  expression: "!paginaStatus.desabilitarEdicao"
                }
              ],
              staticClass: "fixed",
              staticStyle: { right: "18px", bottom: "18px" },
              attrs: {
                round: "",
                id: "salvar",
                name: "salvar",
                color: "positive",
                icon: "check",
                size: "lg"
              },
              on: { click: _vm.salvar }
            },
            [_c("q-tooltip", [_vm._v("Salvar")])],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }